import { api } from "../lib/api";

export async function listCalculators() {
  return api.get("/api/calculate");
}

export async function runAll() {
  return api.post("/api/calculate", {});
}
